import { Component, signal, inject, ViewEncapsulation } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink, RouterLinkActive } from '@angular/router';
import { MenuItem } from '../../core/models/sidebar.js';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDividerModule } from '@angular/material/divider';
import { SidebarService } from '../../core/services/sidebar.service';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [
    MatListModule,
    MatIconModule,
    RouterLink,
    RouterLinkActive,
    MatSidenavModule,
    MatDividerModule,
    TranslateModule
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class SidebarComponent {
  private sidebarService = inject(SidebarService);
  private router = inject(Router);

  menuItems = signal<MenuItem[]>([]);

  constructor() {
    this.menuItems.set(this.sidebarService.getMenuItems());
  }

  toggleSubmenu(item: MenuItem, event: Event) {
    if (this.hasSubmenu(item)) {
      event.preventDefault();
      item.showSubmenu = !item.showSubmenu;
      if (item.showSubmenu && item.route) {
        this.router.navigate([item.route]);
      }
    }

    this.closeSiblingSubmenus(item);
  }

  private closeSiblingSubmenus(item: MenuItem) {
    const parentItems = this.findParentItems(item);
    parentItems.forEach(parent => {
      parent.submenu?.forEach(sibling => {
        if (sibling !== item && sibling.showSubmenu) {
          sibling.showSubmenu = false;
        }
      });
    });
  }

  isSubmenuOpen(item: MenuItem): boolean {
    return !!item.showSubmenu;
  }

  hasSubmenu(item: MenuItem): boolean {
    return !!item.submenu && item.submenu.length > 0;
  }

  private findParentItems(item: MenuItem): MenuItem[] {
    const parents: MenuItem[] = [];
    const search = (items: MenuItem[], target: MenuItem): boolean => {
      return items.some(parent => {
        if (parent.submenu?.includes(target)) {
          parents.push(parent);
          return true;
        }
        return search(parent.submenu || [], target);
      });
    };
    search(this.menuItems(), item);
    return parents;
  }
}